// Ported from vlookup-dramatic/components/icon.tsx by scripts/revamp/port-design.js
import React from "react";
import Image from "./image";
import { cn } from "../lib/utils";
// Client-selected Flaticon outline icons (see PPT "vlu new site icons"),
// recolored to brand blue. Files live in /public/images/icons/<name>.png.
export const ICON_NAMES = [
    "target", "star", "building", "edit", "handshake", "rocket", "brain",
    "inclusion", "grid", "community", "idea", "toolkit", "mail", "play",
    "globe", "sparkle", "tag", "chart", "ai", "calendar", "gear",
    "graduation", "shieldcheck", "book", "code", "science", "growth", "flame",
    "success", "tutorial", "question", "list", "keyperson", "experience",
    "armwrestling", "initiative", "resume", "choice", "help", "mentoring",
    "lotus", "coaching", "settings", "worldwide", "alliance", "development",
    "creative", "indicator", "peopletogether", "timemanagement",
    "configuration", "deployment", "graduationhat", "ergs",
];
export function Icon({ name, className, size = 96, }) {
    const safe = ICON_NAMES.includes(name)
        ? name
        : "sparkle";
    const src = `/revamp/images/icons/${safe}.png`;
    return (<Image src={src} alt="" aria-hidden width={size} height={size} className={cn("object-contain", className)}/>);
}
